import { QueryClient } from '@tanstack/react-query';

// Конфигурация React Query
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 минут
      gcTime: 1000 * 60 * 30, // 30 минут (было cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

// Query keys для типобезопасности
export const queryKeys = {
  games: ['games'] as const,
  game: (gameId: string) => ['games', gameId] as const,
  gameModes: (gameId: string) => ['games', gameId, 'modes'] as const,
  gameMode: (gameId: string, modeId: string) => ['games', gameId, 'modes', modeId] as const,
};
